export default __webpack_public_path__ + "static/media/Metropolis-Medium.cdcce862.otf";